import { mapState, mapGetters } from 'vuex'
import { getHost } from '@/utils/host'
import VueClipboard from 'vue-clipboard2'
import Vue from 'vue'
import { Toast } from 'vant'
import { setRouteBase } from '@/config/routePrefix'
import {
  shareToFacebook,
  shareToTwitter,
  shareToWhatsApp,
  shareToEmail,
  shareToMessenger,
  shareToVK,
  shareToTelegram,
} from '@/utils/share'
import { shareConfigs, facebook_app_id } from '@/components/PublicShare/consts'
import { getEnv } from '@/utils/env'
import { appShareByWay } from '@/utils/native'
import { shareClick } from '@/pages/firebase'
import { getQuery } from '@/utils/utils'
import { isLargerThanVersion } from '@/utils/toplupeVersion.js'

Vue.use(VueClipboard)
Vue.use(Toast)

export default {
  props: {
    // 分享是否在callback中执行
    hasCallback: {
      type: Boolean,
      default: false,
    },
    getContainer: {
      type: String,
      default: '',
    },
    moduleName: {
      type: String,
      default: '',
    },
    currentPage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showPopup: false,
      copyText: '',
      shareInfos: {},
      // activitySource: '', //活动生效渠道
      page: '',
    }
  },
  computed: {
    ...mapState([
      'isMobile',
      'isDesktop',
      'isApp',
      'region',
      'gameName',
      'shareTitle',
      'layoutVersion',
    ]),
    ...mapGetters(['isNewLayout']),
    className() {
      if (this.isNewLayout) {
        if (this.layoutVersion === 'version-2-2') {
          return 'new-version'
        } else {
          return 'new-version black-theme'
        }
      }
      return ''
    },
    shareOptions() {
      const {
        facebook,
        twitter,
        whatsapp,
        messenger,
        email,
        vk,
        telegram,
        copyLink,
      } = shareConfigs

      const copyLinkInfos = copyLink(this.$t('common.copyLink'))

      if (this.region === 'ru') {
        // 目前APP只支持3中分享方法
        if (this.isApp && !isLargerThanVersion('2.1.0')) {
          return [whatsapp, copyLinkInfos, twitter, email]
        }
        return [whatsapp, vk, telegram, copyLinkInfos, twitter, email]
      }
      // 目前APP只支持3中分享方法
      if (this.isApp && !isLargerThanVersion('2.1.0')) {
        return [facebook, whatsapp, twitter, email, copyLinkInfos]
      } else {
        return [facebook, whatsapp, twitter, messenger, email, copyLinkInfos]
      }
    },
    activitySource() {
      return getQuery('activitySource') || getQuery('source') || ''
    },
    commonQueryString() {
      return `source=share${
        this.activitySource ? '&activitySource=' + this.activitySource : ''
      }`
    },
    getShareTitle() {
      return (
        this.shareTitle || this.$t(`common.slogan`) || 'TopLupe - Trust & Bonus'
      )
    },
  },
  watch: {
    showPopup(val) {
      if (val) {
        this.$emit('onshow')
      } else {
        this.$emit('onhide')
      }
    },
  },
  created() {
    if (!process.client) return
    this.setToastStyle()
  },
  mounted() {
    this.page = this.currentPage || this.gameName || ''
    // 设置默认值
    this.setCopyText()
    this.setShareInfo()
  },
  methods: {
    setPageName(page) {
      this.page = page
      this.setShareInfo()
      this.setCopyText()
    },
    setShareInfo(configs) {
      if (configs && typeof configs === 'object') {
        this.shareInfos = configs
        this.page = configs.page || this.currentPage || this.gameName || ''
      } else {
        const fix = setRouteBase() === '/' ? '' : setRouteBase()
        const shareTitle = this.getShareTitle
        const hostMaps = {
          test: 'https://www-staging.toplupe.com',
          preview: window.location.origin,
          online: window.location.origin,
        }
        const shareUrl = `${hostMaps[getEnv()]}${fix}/${this.page}?${
          this.commonQueryString
        }`
        this.shareInfos = {
          shareTitle,
          shareUrl,
        }
      }
    },
    setCopyText(copyText) {
      if (copyText) {
        this.copyText = copyText
      } else {
        this.copyText = this.getShareTitle + '\n' + this.getShareUrl('copyLink')
      }
    },
    switch() {
      this.showPopup = !this.showPopup
    },
    closePopup() {
      this.switch()
    },
    setToastStyle() {
      if (!process.client) {
        return
      }
      const head = document.querySelector('head')
      const style = document.createElement('style')
      style.type = 'text/css'
      style.innerText = `.copy-toast { word-break: break-word}`
      head.appendChild(style)
    },
    onCopySuccess() {
      this.$emit('copy-success')
      Toast.success({
        message: this.$t('common.copyLinkSuccess'),
        duration: 1500,
        className: 'copy-toast',
      })
    },
    onCopyError() {
      this.$emit('copy-fail')
      Toast.fail({
        message: 'failed!',
        duration: 1500,
      })
    },
    goToShare(list = {}) {
      const { id = '' } = list
      const channelName = id.toLocaleLowerCase()
      shareClick({ page: this.page, share_name: channelName })

      const shareChannelMaps = {
        facebook: shareToFacebook,
        twitter: shareToTwitter,
        whatsapp: shareToWhatsApp,
        messenger: shareToMessenger,
        email: shareToEmail,
        vk: shareToVK,
        telegram: shareToTelegram,
        copylink: () => {},
      }

      let { shareTitle, shareUrl } = this.shareInfos
      // 防止自定义传递时缺少分享相关的参数
      if (shareUrl.indexOf('source') === -1) {
        shareUrl = `${shareUrl}${shareUrl.indexOf('?') === -1 ? '?' : '&'}${
          this.commonQueryString
        }`
      }
      if (shareUrl.indexOf('channelId') === -1) {
        shareUrl = `${shareUrl}&${this.addQuery(channelName)}`
      }
      const shareInfos = {
        shareTitle,
        shareUrl,
        app_id: facebook_app_id,
      }

      if (this.isApp && !this.hasCallback) {
        // app中复制粘贴和email走h5的逻辑
        if (channelName === 'copylink' || channelName === 'email') {
          shareChannelMaps[channelName] &&
            shareChannelMaps[channelName](shareInfos)
          this.switch()
          return
        } else {
          // 其他则调用APP的分享方法
          let appShareOptions = JSON.stringify({
            url: shareUrl,
            content: shareTitle,
          })
          appShareByWay(channelName, appShareOptions)
          return
        }
      }

      this.$emit('to-share', list, (_shareInfos) => {
        const newShareInfos = _shareInfos || shareInfos
        const { shareTitle, shareUrl } = newShareInfos
        // 在app中，使用h5的分享面板，调用APP的分享方法
        if (this.isApp) {
          // app中复制粘贴和email走h5的逻辑
          if (channelName === 'copylink' || channelName === 'email') {
            shareChannelMaps[channelName] &&
              shareChannelMaps[channelName](newShareInfos)
          } else {
            let appShareOptions = JSON.stringify({
              url: shareUrl,
              content: shareTitle,
            })
            appShareByWay(channelName, appShareOptions)
          }
        } else {
          shareChannelMaps[channelName] &&
            shareChannelMaps[channelName](_shareInfos || shareInfos)
        }
        this.switch()
      })
      if (!this.hasCallback) {
        shareChannelMaps[channelName] &&
          shareChannelMaps[channelName](shareInfos)
        this.switch()
      }
      this.$emit('finished', list)
    },
    getShareUrl(channelName) {
      if (!process.client) {
        return
      }
      const fix = setRouteBase() === '/' ? '' : setRouteBase()
      const pathName = this.page || ''
      let shareUrl = `${getHost()}${fix}/${pathName}?${
        this.commonQueryString
      }&${this.addQuery(channelName)}`
      return shareUrl
    },
    addQuery(channelName) {
      const slogan = window.abtest_shareQuery_text || 'toplupe'
      return `channelId=${channelName}&platform=h5&slogan=${slogan}`
    },
  },
}
